import PMSSchedulesCalendar from 'app/components/scheduling/PMSSchedulesCalendar'
import { usePmsSchedulesLocation } from 'app/components/pms-schedules-location/usePmsSchedulesLocation'

export default function AvailabilityCalendarRoute() {
  const data = usePmsSchedulesLocation()
  return <PMSSchedulesCalendar {...data} />
}
